import { tns } from "tiny-slider";

function tinySlider() {
    let sliders = document.querySelectorAll('.ml-slider');
    Array.prototype.slice.call(sliders)
        .forEach(function (slider) {
            let carrusel = tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                controls: false, //arrow next prev
                nav: true, //bullets
                navPosition: 'bottom',
                autoHeight: true,
                mouseDrag: true,
                autoplay: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                autoplayResetOnVisibility: false
            });
        })
}
export { tinySlider }
